import { render, staticRenderFns } from "./PoultryHouses.vue?vue&type=template&id=784d9f7b&scoped=true&"
import script from "./PoultryHouses.vue?vue&type=script&lang=js&"
export * from "./PoultryHouses.vue?vue&type=script&lang=js&"
import style0 from "./PoultryHouses.vue?vue&type=style&index=0&id=784d9f7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784d9f7b",
  null
  
)

export default component.exports